<template>
  <div class="accordeon-item" :class="{ 'is-active': active}">
    <div class="accordeon-button" @click="$emit('select')">
      <div>
        <small v-if="topTitle">{{ topTitle }}</small>
        <strong>{{ title }}</strong>
      </div>
    </div>
    <transition name="slide-up">
    <div class="accordeon-content" v-if="active">
      <slot></slot>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AccordeonItem",
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    topTitle: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    }
  }
}
</script>


<style scoped lang="scss">
.accordeon-item {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;

  &:last-child:not(.is-active) {

    .accordeon-button {
      border-bottom: 0;
    }
  }

  &.is-active {
    flex: 1;

    .accordeon-button {
      cursor: default;
      box-shadow: 0 45px 104px 1px rgba(0, 0, 0, .03);
      border-bottom: 1px solid rgba(239, 239, 239, 0.94);

      strong {
        color: #1f1f1f;
      }
    }
  }

  .accordeon-button {
    cursor: pointer;
    flex-shrink: 0;
    height: 2.8125rem;
    display: flex;
    align-items: center;
    padding: 0 2.1875rem;
    border-top: 1px solid rgba(239, 239, 239, 0.94);
    background: #FFFFFF;
    z-index: 2;
    position: relative;

    &:hover {

      strong {
        color: #1F1F1F;
      }
    }

    small {
      font-size: 0.625rem;
      line-height: 1;
      text-transform: uppercase;
      display: block;
    }

    strong {
      color: #6A7272;
      line-height: 1;
      font-size: 0.9375rem;
      display: block;
      transition: color .3s ease;
    }
  }

  .accordeon-content {
    padding: 1rem 2.1875rem;
    overflow: scroll;
    height: 100%;
  }
}
</style>
